'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _ramda = require('ramda');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fund_financial_calendar_data_point = require('./fund_financial_calendar_data_point');

var _fund_financial_calendar_data_point2 = _interopRequireDefault(_fund_financial_calendar_data_point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundFinancialCalendarCard = function (_React$Component) {
  _inherits(FundFinancialCalendarCard, _React$Component);

  function FundFinancialCalendarCard(props) {
    _classCallCheck(this, FundFinancialCalendarCard);

    var _this = _possibleConstructorReturn(this, (FundFinancialCalendarCard.__proto__ || Object.getPrototypeOf(FundFinancialCalendarCard)).call(this, props));

    _this.renderFundFinancialCalendarData = _this.renderFundFinancialCalendarData.bind(_this);
    _this.fundFinancialCalendarMap = _this.fundFinancialCalendarMap.bind(_this);
    return _this;
  }

  _createClass(FundFinancialCalendarCard, [{
    key: 'renderFundFinancialCalendarData',
    value: function renderFundFinancialCalendarData() {
      var fundFinancialCalenarMarkup = [];

      if ((0, _ramda.isNil)(this.props.visibleFinancialCalendar) || (0, _ramda.isEmpty)(this.props.visibleFinancialCalendar)) {
        return null;
      }

      for (var i = 0; i <= this.props.visibleFinancialCalendar.length; i++) {
        fundFinancialCalenarMarkup.push(this.fundFinancialCalendarMap(this.props.visibleFinancialCalendar[i]));
      }

      return fundFinancialCalenarMarkup;
    }
  }, {
    key: 'fundFinancialCalendarMap',
    value: function fundFinancialCalendarMap(key) {
      var fundStatsMap = {
        "INTERIM_RESULTS_ANNOUNCED": _react2.default.createElement(_fund_financial_calendar_data_point2.default, {
          label: 'Interim results announced',
          dataTest: 'fund-financial-calendar-interim-results-announced',
          key: 'fund-financial-calendar-interim-results-announced',
          value: this.props.interimResultsAnnouncedPeriod }),

        "FINAL_RESULTS_ANNOUNCED": _react2.default.createElement(_fund_financial_calendar_data_point2.default, {
          label: 'Final results announced',
          dataTest: 'fund-financial-calendar-final-results-announced',
          key: 'fund-financial-calendar-final-results-announced',
          value: this.props.finalResultsAnnouncedPeriod }),

        "ANNUAL_GENERAL_MEETING": _react2.default.createElement(_fund_financial_calendar_data_point2.default, {
          label: 'Annual general meeting',
          dataTest: 'fund-financial-calendar-annual-general-meeting',
          key: 'fund-financial-calendar-annual-general-meeting',
          value: this.props.annualGeneralMeetingPeriod }),

        "FINANCIAL_YEAR_END_DATE": _react2.default.createElement(_fund_financial_calendar_data_point2.default, {
          label: 'Financial year-end date',
          dataTest: 'fund-financial-calendar-fiscal-year-end',
          key: 'fund-financial-calendar-fiscal-year-end',
          value: this.props.fiscalYearEnd }),

        "DIVIDENDS_PAYABLE": _react2.default.createElement(_fund_financial_calendar_data_point2.default, {
          label: 'Dividends payable',
          dataTest: 'fund-financial-calendar-dividends-payable',
          key: 'fund-financial-calendar-dividends-payable',
          value: this.props.dividendsPayable,
          suppressIfNull: true })
      };

      return fundStatsMap[key];
    }
  }, {
    key: 'render',
    value: function render() {

      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: 'financial-calendar',
          headerTitle: _string_utility2.default.renderFormattedLabel("Financial calendar", "pdp-overview-financial-calendar-header"),
          headerTitleId: "fund-financial-calendar",
          headerTitleLabel: "",
          headerLabel: "",
          displayStyle: 'width-percent-100 margin-left-0 float-left',
          breakpoints: this.props.breakpoint,
          breakpoint: this.props.breakpoint,
          placementId: "pdpCardFundFinancialCalendar"
        },
        _react2.default.createElement(
          'div',
          null,
          this.renderFundFinancialCalendarData()
        )
      );
    }
  }]);

  return FundFinancialCalendarCard;
}(_react2.default.Component);

exports.default = FundFinancialCalendarCard;